import React from 'react';
import { Link } from 'react-router-dom';
import './FormCard.css';

const FormCard = ({ formName, iconType, url }) => {
  // Extract form number if present in parentheses
  const extractFormNumber = (name) => {
    const match = name.match(/\(([^)]+)\)/);
    if (match) return match[1];
    
    // For forms without parentheses but with "Form" prefix (like "IRS Form 5471")
    const formMatch = name.match(/Form\s+([0-9A-Z-]+)/i);
    if (formMatch) return formMatch[1];
    
    return null;
  };

  const formNumber = extractFormNumber(formName);
  
  // Clean name by removing parenthetical content
  const cleanName = formName.replace(/\s*\([^)]*\)\s*/, ' ').trim();

  // Return the appropriate icon based on the icon type
  const renderIcon = () => {
    switch (iconType) {
      case 'irs-form':
        return (
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM13 7H11V9H13V7ZM13 11H11V17H13V11ZM7 7H9V9H7V7ZM7 11H9V17H7V11ZM15 7H17V9H15V7ZM15 11H17V17H15V11Z" fill="#333"/>
          </svg>
        );
      case 'tax':
        return (
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z" fill="#333"/>
          </svg>
        );
      case 'dissolution':
        return (
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="#333"/>
          </svg>
        );
      case 'incorporation':
        return (
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z" fill="#333"/>
          </svg>
        );
      case 'certificate':
        return (
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM11 14L9.5 12.5L10.91 11.09L11 11.17L11.09 11.09L12.5 12.5L11 14ZM13 10.17L12.09 9.26L17 4.35L17.91 5.26L13 10.17ZM5.35 7.35L6.26 6.44L8.77 8.95L7.86 9.86L5.35 7.35Z" fill="#333"/>
          </svg>
        );
      case 'agent':
        return (
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 3H4.99C3.89 3 3 3.9 3 5L3.01 19C3.01 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 15H15C15 16.66 13.65 18 12 18C10.35 18 9 16.66 9 15H4.99V5H19V15Z" fill="#333"/>
          </svg>
        );
      case 'fincen':
        return (
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 18V19H3V18H21ZM21 16H3V5H21V16ZM14 11.5C14 10.12 12.88 9 11.5 9C10.12 9 9 10.12 9 11.5C9 12.88 10.12 14 11.5 14C12.88 14 14 12.88 14 11.5Z" fill="#333"/>
          </svg>
        );
      case 'valuation':
        return (
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 18V21H3V18H21ZM6 10L12 16L18 10L21 13V3H3V13L6 10Z" fill="#333"/>
          </svg>
        );
      case 'annual-report':
        return (
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 10.5C3.17 10.5 2.5 11.17 2.5 12C2.5 12.83 3.17 13.5 4 13.5C4.83 13.5 5.5 12.83 5.5 12C5.5 11.17 4.83 10.5 4 10.5ZM4 4.5C3.17 4.5 2.5 5.17 2.5 6C2.5 6.83 3.17 7.5 4 7.5C4.83 7.5 5.5 6.83 5.5 6C5.5 5.17 4.83 4.5 4 4.5ZM4 16.5C3.17 16.5 2.5 17.18 2.5 18C2.5 18.82 3.18 19.5 4 19.5C4.82 19.5 5.5 18.82 5.5 18C5.5 17.18 4.83 16.5 4 16.5ZM7 19H21V17H7V19ZM7 13H21V11H7V13ZM7 5V7H21V5H7Z" fill="#333"/>
          </svg>
        );
      default:
        return (
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 5V19H5V5H19ZM21 3H3V21H21V3ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z" fill="#333"/>
          </svg>
        );
    }
  };

  return (
    <Link to={url} className="form-card">
      <div className={`form-icon-container ${iconType}`}>
        <div className="form-icon">
          {renderIcon()}
          {formNumber && <span className="form-number">{formNumber}</span>}
        </div>
      </div>
      <h3 className="form-title">{cleanName}</h3>
    </Link>
  );
};

export default FormCard; 